module.exports = __webpack_public_path__ + "img/EXTERIOR-ERTIGA-2.84d832f9.jpg";